import * as React from "react";
function ArrowRightIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px",
    "data-rtl-flip": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 12.75h22.5a.75.75 0 0 0 0-1.5H.75a.75.75 0 0 0 0 1.5m12.53 10.28 10.5-10.5a.75.75 0 0 0 0-1.06L13.28.97a.75.75 0 1 0-1.06 1.06l10.5 10.5v-1.06l-10.5 10.5a.75.75 0 1 0 1.06 1.06"
  }));
}
export default ArrowRightIcon;